/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import Header from '../../components/Header';
import Search from '../../components/Search';
import Tile from '../../components/Tile';
import DocListModal from '../../components/DocList';
import Footer from '../../components/Footer';
import './style.scoped.scss';
import Loader from '../../components/Loader';
import { setCurrentDocument } from '../../store/Document/documentActions';
import { ROUTES } from '../../assets/constants/strings';
import { Redirect, Link } from 'react-router-dom';
// import WelcomeModal from '../../components/Modals/Welcome';
import ReactGA from 'react-ga';
import Animation from '../../components/Animation';
import config from '../../config';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import RegulatorViewIcon from '../../assets/RegulatorViewIcon.svg';
import DashboardIcon from '../../assets/DashboardIcon.svg';
import Dashboard from '../../components/Dashboard';
import { BsChatSquareQuoteFill } from 'react-icons/bs';
import { DispatchSearch } from '../../store/Search/searchActions';

const Home = ({
  structure,
  levelOneList,
  levelTwoList,
  levelThreeList,
  levelFourList,
  // logo,
  documents,
  currentPage,
  currentDoc,
  setCurrentDocument,
  user,
  clientProccessesRunning,
  DispatchSearch,
}) => {
  // const [showWelcome, setShowWelcome] = useState(
  //   user && user.firstTimeLogin === true
  // );

  const [view, setView] = useState('view');

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 425);

  const [redirectUser, setRedirectUser] = useState(false);

  // using refs to ensure the load logic works
  const screenRef = useRef(isSmallScreen);
  screenRef.current = isSmallScreen;

  useEffect(() => {
    // listen for changes in window width for hide/show logic
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const checkScreenSize = () => {
    screenRef.current = window.innerWidth > 425;
    setIsSmallScreen(screenRef.current);
  };

  useEffect(() => {
    document.title = 'Home - Regulation City';

    // Google Analytics uncomment next line to enable
    ReactGA.initialize('UA-188442605-15');

    // deactivate scroll listeners
    $('#wf-scroll-wrapper').off('scroll', null);
    $(window).off('resize', null);

    return () => {
      if (document.getElementsByClassName('modal-backdrop').length > 0) {
        document.getElementsByClassName('modal-backdrop')[0].remove();
      }
    };
  }, []);

  // useEffect(() => {
  //   if (user) {
  //     setShowWelcome(user.firstTimeLogin === true);
  //   }
  //   const IsLoggedIn = localStorage.getItem('loggedIn') === 'true';
  //   if (IsLoggedIn) ReactGA.set({ userId: user.userID });
  // }, [user]);

  useEffect(() => {
    if (currentPage !== null || currentDoc !== null) setCurrentDocument(null);
  });

  const TileList = () => {
    if (levelOneList.length < 1) {
      return (
        // if there isn't
        <div
          className='alert alert-secondary mx-auto font-weight-bold'
          role='alert'
          aria-label='No Documents'
        >
          <span>
            Unable to access RegulationCity content. If you think this is a
            mistake, please
            <a
              href={`${config.WordPressURL}help`}
              target='_blank'
              rel='noreferrer'
            >
              {' '}
              contact us.
            </a>
          </span>
        </div>
      );
    } else
      return clientProccessesRunning !== 0 ? (
        <Animation />
      ) : (
        levelOneList.map((lvl1, index) => {
          return (
            <Tile
              key={index}
              level={lvl1}
              index={index}
              toggleDisplayDocuments={handleTileSelected}
            />
          );
        })
      );
  };

  //#region MODAL BEHAVIOURS

  const [searchInput, setSearchInput] = useState(null);
  const [selectedLevelOne, setSelectedLevelOne] = useState(null);

  const handleSearch = (input) => {
    setSearchInput(input);
    DispatchSearch(input);
    setRedirectUser(true);
  };

  const handleTileSelected = (level) => {
    setSelectedLevelOne(level);
    $('#DocsListModal').modal('show');
    $('.modal-backdrop').appendTo('#home-page');
  };

  const handleOnDismiss = () => {
    setSelectedLevelOne(null);
  };

  // logic to prevent first time login modal not show again
  // const handleFirstTime = () => {
  //   setShowWelcome(false);
  //   updateUserInfo(
  //     {
  //       id: user.userID,
  //       firstTimeLogin: false,
  //     },
  //     true
  //   );
  // };

  //#endregion

  // console.log('structure', structure,
  //   '\n\n logo', logo,
  //   '\n\n levelOneList', levelOneList,
  //   '\n\n levelTwoList', levelTwoList,
  //   '\n\n levelThreeList', levelThreeList,
  //   '\n\n levelFourList', levelFourList,
  //   '\n\n documents', documents !== null ? documents.length : null,
  // );

  // removed the client processes running logic to be able to fetch all apis
  // that will be used on the document page prior to the user going there,
  // so there will never be any load after this one
  // variables that we need on home page

  // if (searchInput !== null) {
  //   return <Redirect to={ROUTES.SEARCH(searchInput)} />;
  // }

  if (redirectUser) return <Redirect to={ROUTES.SEARCH} />;

  if (!user) {
    return <Redirect to={ROUTES.LOGIN} />;
  } else if (user && !user.isActive) {
    return <Redirect to={ROUTES.LOGIN} />;
  } else if (
    user &&
    user.isActive &&
    (!structure ||
      // logo === null ||
      !documents ||
      !levelOneList ||
      !levelTwoList ||
      levelThreeList === null ||
      levelFourList === null)
  ) {
    return (
      <div className='page-loader-wrapper'>
        <Loader />
      </div>
    );
  } else {
    return (
      <div id='home-page'>
        <div className='background'>
          <div className='background__page-wrapper'>
            <Header isHome />

            <main role='main' className='home'>
              <div className='home__userView'>
                <div className='home__btnGroup'>
                  <ButtonGroup aria-label='Basic example'>
                    <Button
                      className={`home__btnGroup__btn${
                        view === 'dashboard' ? '__active' : ''
                      }`}
                      onClick={() => setView('dashboard')}
                    >
                      <img src={DashboardIcon} alt='' />
                      <span className='ml-2'>RegCity Dashboard</span>
                    </Button>
                    <Button
                      id='regulator-view'
                      className={`home__btnGroup__btn${
                        view === 'view' ? '__active' : ''
                      }`}
                      onClick={() => setView('view')}
                    >
                      <img src={RegulatorViewIcon} alt='' />
                      <span className='ml-2'>Home</span>
                    </Button>
                  </ButtonGroup>
                </div>
                <div className='home__query'>
                  <Link to={ROUTES.QUERY}>
                    <Button className='home__query__btn'>
                      <span className='mr-2'>
                        <BsChatSquareQuoteFill />
                      </span>
                      {isSmallScreen ? 'Query AI' : ''}
                    </Button>
                  </Link>
                  <Search handleSearch={handleSearch} mobileLg />
                </div>
              </div>

              {view === 'dashboard' ? (
                <Dashboard />
              ) : (
                <div className='row home__tiles'>
                  {levelOneList && TileList()}
                </div>
              )}

              <DocListModal
                selectedLevel={{ level: 'levelOne', value: selectedLevelOne }}
                onDismiss={handleOnDismiss}
                handleSearch={handleSearch}
              />
            </main>
          </div>
        </div>
        <Footer isCentered />
        {/* {user && user.firstTimeLogin === true && (
          <WelcomeModal
            show={showWelcome}
            onDismiss={() => setShowWelcome(false)}
            handleFirstTime={handleFirstTime}
          />
        )} */}
      </div>
    );
  }
};

const mapStateToProps = (state) => ({
  clientName: state.client.clientName,
  structure: state.client.spStructure,
  levelOneList: state.client.levelOneList,
  levelTwoList: state.client.levelTwoList,
  levelThreeList: state.client.levelThreeList,
  levelFourList: state.client.levelFourList,
  // logo: state.client.logo,
  documents: state.client.documents,
  rightNav: state.client.rightNav,
  glossary: state.client.glossaryList,
  relatedContent: state.client.relatedContent,
  clientProccessesRunning: state.client.proccessesRunning,
  currentPage: state.document.currentPage,
  currentDoc: state.document.currentDocument,
  user: state.user.user,
  bookmarks: state.user.bookmarks,
  cards: state.user.cards,
  transactions: state.user.transactions,
});

const mapDispatchToProps = {
  setCurrentDocument,
  DispatchSearch,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(Home);
